<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "ProductAvailabilityState",
        components: {
            TheSvgIcon,
        },
        props: {
            isAvailable: Boolean,
            isCommon: Boolean,
        },
        computed: {
            state() {
                return {
                    name: this.isAvailable ? "availability" : "not_availability",
                    text: this.isAvailable ? "Товар в наличии" : "Нет в наличии",
                };
            },
        },
    };
</script>

<template>
    <div class="c-availability" :class="{ 'c-availability--active': isAvailable }">
        <the-svg-icon :name="state.name" :is-common="isCommon" :size-w="24"></the-svg-icon>
        {{ state.text }}
    </div>
</template>

<style lang="scss">
    .c-availability {
        display: flex;
        font-size: 14px;
        line-height: 24px;
        color: var(--product-unavailable-color);

        svg {
            margin-right: 4px;
        }
    }

    .c-availability--active {
        color: var(--success);
    }
</style>
